import { call, put, takeEvery, } from 'redux-saga/effects';
import { callApi, callApiWithNoAuth, Method } from '../../api/Api';
import { stopLoading, showErrorMessage, startLoading } from '../layout/action';
import { GET_DASHBOARD_EMAIL_VERIFICATION, GET_DASHBOARD_WITHOUT_SESSION, GET_DASHBOARD_WITH_SESSION, GET_DASHBOARD_WITH_SESSION_ACCOUNT_IDENTIFIER, GET_DASHBOARD_WITH_SESSION_SHIBBOLETH, setDashboardEmailVerification, setDashboardHtmlWithSession, setDashboardHtmlWithSessionAccountIdentifier, setDashboardHtmlWithSessionShibboleth } from './action';
import { setDashboardHtmlWithoutSession } from './action'

export function* watchGetCustomerDashboardWithoutSession() {
    yield takeEvery(GET_DASHBOARD_WITHOUT_SESSION, function* ({ payload }) {
        try {
            yield put(startLoading())
            const response = yield call(callApiWithNoAuth, {
                 method: Method.GET,
                url: `/portal/pages/home-without-session/${payload.customerName}`
               
            });
            yield put(setDashboardHtmlWithoutSession(response.data[0] || { text: "" }))
            yield put(stopLoading())
        }
        catch (err) {
            yield put(stopLoading())
            yield put(showErrorMessage({ error: err, title: "GET DASHBOARD HTML" }));
        }
    })
}

export function* watchGetCustomerDashboardWithSession() {
    yield takeEvery(GET_DASHBOARD_WITH_SESSION, function* ({ payload }) {
        try {
            yield put(startLoading())
            const response = yield call(callApi, {
                url: `/portal/pages/home/${payload.customerName}`,
                method: Method.GET
            });
            yield put(setDashboardHtmlWithSession(response.data[0] || { text: "" }))
            yield put(stopLoading())
        }
        catch (err) {
            yield put(stopLoading())
            yield put(showErrorMessage({ error: err, title: "GET DASHBOARD HTML" }));
        }
    })
}

export function* watchGetCustomerDashboardWithSessionShibboleth() {
    yield takeEvery(GET_DASHBOARD_WITH_SESSION_SHIBBOLETH, function* ({ payload }) {
        try {
            yield put(startLoading())
            const response = yield call(callApiWithNoAuth, {
                url: `/portal/pages/home-without-session/shibboleth/enable/${payload}`,
                method: Method.GET
            });
            yield put(setDashboardHtmlWithSessionShibboleth(response))
            yield put(stopLoading())
        }
        catch (err) {
            yield put(stopLoading())
            yield put(showErrorMessage({ error: err, title: "GET DASHBOARD HTML" }));
        }
    })
}

//  Get Account Identifier ID

export function* watchGetCustomerDashboardWithSessionAccountIdentifier() {
    yield takeEvery(GET_DASHBOARD_WITH_SESSION_ACCOUNT_IDENTIFIER, function* ({ payload }) {
        try {
            yield put(startLoading())
            const response = yield call(callApiWithNoAuth, {
                // url: `/clients/account-identifier/${payload}`,
                url: `/portal/pages/home-without-session/account-identifier/${payload}`,
                method: Method.GET
            });
            yield put(setDashboardHtmlWithSessionAccountIdentifier(response))
            yield put(stopLoading())
        }
        catch (err) {
            yield put(stopLoading())
            yield put(showErrorMessage({ error: err, title: "GET DASHBOARD HTML" }));
        }
    })
}

// Email Verification

export function* watchGetCustomerDashboardEmailVerification() {
    yield takeEvery(GET_DASHBOARD_EMAIL_VERIFICATION, function* ({ payload }) {
        try {
            yield put(startLoading())
            const response = yield call(callApiWithNoAuth, {
                // url: `/driveraccount/check_username/${payload}`,
                url: `/portal/pages/home-without-session/check_username/${payload?.userName}/${payload?.groupName}`,
                method: Method.GET
            });
            yield put(setDashboardEmailVerification(response))
            yield put(stopLoading())
        }
        catch (err) {
            yield put(stopLoading())
            yield put(showErrorMessage({ error: err, title: "This User Name Already Exist" }));
        }
    })
}
